import {connect} from 'react-redux';
import {TaskTracker as Component} from './TaskTracker';

import {
  focusFirstTask,
  setTaskCompleted,
  clearLastActions,
  incTempPoints,
  clearTempPoints,
  saveSnapshot
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    //Internal Tracker Props
    protocolSection: state.notebook.protocolSection,

    lastActions: state.notebook.protocolSection.scene.lastActions,
    focusedPage: state.notebook.protocolSection.scene.focusedPage,
    focusedTask: state.notebook.protocolSection.scene.focusedTask,
    focusedTaskObj: state.notebook.protocolSection.scene.focusedTaskObj,
    points: state.notebook.protocolSection.scene.tempPoints,
    critChecks: state.notebook.protocolSection.scene.critChecks,

    //States to check props
    pipettes: state.notebook.protocolSection.scene.apparatus.pipettes,
    solutions: state.notebook.protocolSection.scene.apparatus.solutions,
    tipBoxes: state.notebook.protocolSection.scene.apparatus.tipBoxes,
    centrifuge: state.notebook.protocolSection.scene.apparatus.microcentrifuge,
    thermocyclers: state.notebook.protocolSection.scene.apparatus.thermocyclers,
    trash: state.notebook.protocolSection.scene.apparatus.trash,
    modal: state.notebook.protocolSection.scene.modal,

    scene: state.notebook.protocolSection.scene,
    notebook: state.notebook.protocolSection.scene,
    //lastDrop: state.notebook.protocolSection.scene.lastDrop,
    apparatus: state.notebook.protocolSection.apparatus,

    //For Undo function - snapshot of all state
    state: state,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    focusFirstTask: (data) => {
      dispatch(focusFirstTask(data))
    },
    setTaskCompleted: (data) => {
      dispatch(setTaskCompleted(data))
    },
    clearLastActions: (data) => {
      dispatch(clearLastActions(data))
    },
    incTempPoints: (data) => {
      dispatch(incTempPoints(data))
    },
    clearTempPoints: (data) => {
      dispatch(clearTempPoints(data))
    },
    saveSnapshot: (data) => {
      dispatch(saveSnapshot(data))
    }
  };
}

export const TaskTracker = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
